export * from "./promocao-edit.component";
export * from "./promocao-browse.component";
